/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import ActiveAssetListBox from '../../../../common/components/ActiveAssetListBox';
import AddAssetModalController from '../../../../common/Modals/Assets/AddAssetModalController';
import ReturnAssetController from '../../../../common/Modals/Assets/ReturnAsset/ReturnAssetController';
import { Grid, Typography } from '@mui/material';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import { fonts, themes } from '../../../../common/themes/themes';
import _ from 'lodash';
import ActivedocCard from '../../../../common/components/ActivedocCard';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { baseDateFormatting } from '../../../../common/helper';
import { DateField } from '../../../../components';
interface propsType {
  activeassetData: any;
  isLoading?: boolean;
  hr_view?: boolean;
  trans?: any;
}

const ActiveAssetsPresenter: React.FC<propsType> = ({
  activeassetData,
  isLoading,
  hr_view,
  trans,
}) => {
  const [addAssetModal, showAddAssetModal] = useState(false);
  const [returnAssetModal, showReturnAssetModal] = useState(false);
  const [returnassetDetails, showReturnassetDetails] = useState([]);

  const handleReturnAssetModal = (actasset: any) => {
    showReturnassetDetails(actasset);
    showReturnAssetModal(true);
  };
  return (
    <>
      <ActivedocCard
        card_title={trans('Active Assets')}
        card_subtitle={`${trans('Total')} : ${activeassetData.length}`}
        card_height="330px"
        onClick={() => showAddAssetModal(true)}
        isAddButton={hr_view}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <div>
            {activeassetData.length > 0 ? (
              _.map(activeassetData, (actasset: any) => {
                return (
                  <div>
                    <ActiveAssetListBox
                      key={actasset?.asset_id}
                      tile_value={actasset?.brand_name}
                      subtitle1={trans('Asset Id')}
                      assetId={actasset?.asset_id}
                      subtitle2={trans('Asset Type')}
                      assetType={actasset?.name}
                      subtitle3={trans('Assigned')}
                      assignedDate={
                        <DateField
                          value={actasset?.date}
                          format={baseDateFormatting}
                        />
                      }
                      trans={trans}
                      onClick={() => handleReturnAssetModal(actasset)}
                    />
                  </div>
                );
              })
            ) : (
              <Grid container style={{ marginBottom: '3.8em' }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <img src={emptyIcon} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.title,
                      color: themes.blackDefault,
                      fontWeight: 'bold',
                    }}
                  >
                    {trans('Not Added')}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: fonts.fontFamily,
                      fontSize: fonts.subtitle,
                      color: themes.defaultIcon,
                    }}
                  >
                    {trans('Currently you haven’t any Active Assets')}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </div>
        )}
      </ActivedocCard>
      {addAssetModal && (
        <AddAssetModalController
          isModalOpen={addAssetModal}
          closeModal={() => showAddAssetModal(false)}
          trans={trans}
        />
      )}
      {returnAssetModal && (
        <ReturnAssetController
          returnassetDetails={returnassetDetails}
          isModalOpen={returnAssetModal}
          closeModal={() => showReturnAssetModal(false)}
          trans={trans}
        />
      )}
    </>
  );
};
export default ActiveAssetsPresenter;
